export default "__VITE_ASSET__CjKw49q3__"